"use client";

import { NewsCard } from "@otomoro/components/news/NewsCard";
import { NewsCardProps } from "../types";
import { useSearchParams } from "next/navigation";
import { AppList } from '@otomoro/components/shared/AppList';
import { AppTitle } from '@otomoro/components/shared/AppTitle';
import { useRouter, usePathname } from "next/navigation";
import { useState, useEffect } from "react";
import { styles } from './NewsCardsList.css'
import { PortableTextObject } from "sanity";
import { SectionHeader } from "@otomoro/components/shared/SectionHeader";
import { FeaturedNewsCard } from "../../shared/FeaturedNewsCard";
import { LoadMore } from "../LoadMore";

type Props = {
  articles: NewsCardProps[];
  newsPage: Sanity.Default.Schema.NewsPage;
  featuredArticle: any;
  nextArticles: NewsCardProps[] | [];
  activeType: string | null;
};

export function NewsCardsList({
  articles,
  newsPage,
  featuredArticle,
  nextArticles,
  activeType,
}: Props) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [newsArticles, setNewsArticles] = useState(articles);

  const handleClick = (lastPublishedAt: any) => {
    const params = new URLSearchParams(Array.from(searchParams.entries()));
    params.set("lastPublishedAt", lastPublishedAt);
    const search = params.toString();
    router.push(`${pathname}${search ? `?${search}` : ""}`, { scroll: false });
    setNewsArticles((prevArticles) => [...prevArticles, ...nextArticles]);
  };

  useEffect(() => {
    setNewsArticles(articles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeType]);

  if (!newsPage) return

  const { base, header, list, listItems } = styles()

  return (
    <section className={base()}>
      <header className={header()}>
        <SectionHeader tag={newsPage.tag} title={newsPage.title as unknown as PortableTextObject} noPx />
      </header>

      {(featuredArticle && !activeType) && <div className="col-span-full lg:mt-2"><FeaturedNewsCard featuredArticle={featuredArticle} /></div>}

      {articles?.length === 0 ? (
        <AppTitle as="strong" variant="h1" className="w-full mt-6 mb-4 md:mb-0 md:mt-7 mx-auto col-span-4 md:col-span-6 text-center max-md:!text-h2">
          No results found
          {activeType && (
            <>
              <span> for </span>
              <span className="capitalize text-mainPink">{activeType}</span>
            </>
          )}
        </AppTitle>
      ) : (

        <AppList className={list()} itemClassName={listItems()}>
					{(featuredArticle && !activeType) ? (
						newsArticles?.filter((acticle) => acticle._id !== featuredArticle._id).map((article: NewsCardProps, index: number) => (
							<NewsCard key={`news-${index}`} {...article} />
						))
					) : (
						newsArticles?.map((article: NewsCardProps, index: number) => (
							<NewsCard key={`news-${index}`} {...article} />
						))
					)}
        </AppList>
      )}

			<LoadMore
				articles={articles}
				nextArticles={nextArticles}
				onClick={() => handleClick(articles[articles.length - 1].publishedAt)}
			/>
    </section>
  );
}
